import React, { useEffect } from 'react';
import _ from 'lodash'
import { connect } from 'react-redux'
import { SegmentedButton, Button, Panel } from '@sencha/ext-modern'

import { fetchManagerData } from '../Manager/managerUtils'
import { useInstData, useEventHandler } from 'tyan/public/hooks'

const Tasks = props => {
	const { me, setState, me: { state: { currentTask = null } } } = useInstData(props, () => ({ taskList: [], taskCount: 0, tabList: [], tabCount: 0 }))
	const { dispatch, tasks, onTasksLoaded, onTaskSwitch, reloadStamp, maxFetch = 10 } = props
	const doGetTab = () => {
		if (me.unmounted) {
			while (me.tabList.length) {
				me.tabList.shift()[1]()
			}
			return
		}
		while (me.tabCount < maxFetch && me.tabList.length) {
			me.tabCount++
			const [tab, resolve] = me.tabList.shift()
			fetchManagerData(tab.config.columns, tab.path, {
				tabName: tab.tab, numPerPage: -1, pageNum: 1, showFetchSpinner: false,
				onEnd: ({ errorMessage, total }) => {
					!errorMessage && (tab.total = total)
					resolve(errorMessage && ` ${tab.name} ${errorMessage}`)
					me.tabCount--, doGetTab()
				}
			})
		}
	}

	const getOneTaskTotal = async (task) => {
		const promises = []
		task && task.tabs.forEach(tab => promises.push(new Promise(resolve => (me.tabList.push([tab, resolve]), doGetTab()))))
		const values = await Promise.all(promises);
		if (me.unmounted)
			return
		const errs = values.filter(v => v);
		if (errs.length) {
			const err = `读取任务 ${task.name} 错误:<br>${errs.join('<br>')}`
			Ext.toast(err), console.error(`我的任务：${err}`)
		} else {
			task.total = task.tabs.reduce((s, t) => s + (t.total || 0), 0)
			setState({})
		}
		return
	}

	const doGetTask = () => {
		if (me.unmounted)
			return
		while (me.taskCount < maxFetch && me.taskList.length) {
			me.taskCount++
			getOneTaskTotal(me.taskList.shift()).then(() => (me.taskCount--, doGetTask()))
		}
		!me.taskCount && !me.taskList.length && onTasksLoaded && onTasksLoaded()
	}

	const getTasksTotal = async () => {
		let { tasks } = me.props
		if (!tasks) return

		tasks && tasks.forEach(task => me.taskList.indexOf(task) < 0 && me.taskList.push(task))
		doGetTask()
	}

	const switchTask = (task) => currentTask != task && (setState({ currentTask: task }), onTaskSwitch && onTaskSwitch(task))
	const handleTaskChange = useEventHandler((e, v) => switchTask(tasks.find(t => t.name == v)))

	// reload Data
	useEffect(() => {
		getTasksTotal()
	}, [reloadStamp])

	// check and reset currentTask
	useEffect(() => {
		if (!tasks || currentTask && currentTask.total) return
		let current = null
		for (const t of tasks) {
			if (t.total == undefined)
				break
			if (t.total) {
				current = t
				break
			}
		}

		currentTask != current && switchTask(current)
	})

	// useEffect(() => {
	//   const { scroller: { scroller, x, y } = {} } = me.scroller || {}
	//   scroller && scroller.component.isVisible(true) && scroller.scrollTo(x, y)
	// })

	return (
		< Panel docked="left" layout='vbox' margin='0 8 0 0' width="250" shadow
			scrollable//={{ listeners: { scrollend: { fn: handleScroll } } }}
			resizable={{ edges: 'east', dynamic: true }}
		>
			<SegmentedButton defaultUI="toolbar-default" padding="10" value={currentTask && currentTask.name} onChange={handleTaskChange} vertical scrollable='y' >
				{tasks.map(task => (
					<Button noLocale key={task.name} text={`${Tyan.t(task.name, 'nav')} (${task.total != undefined ? task.total : '?'})`} value={task.name} /* badgeText="1" */
						hidden={task.total != undefined && task.total == 0} />
				))}
			</SegmentedButton>
		</Panel >
	)
}

export default connect()(Tasks)